var replace = function (model) { return function (fullMatch, shortMatch) {
    return model[shortMatch] === undefined ? fullMatch : model[shortMatch];
}; };
var interpolate = function (str, values) { return str.replace(/\{([^}]*)}/gi, replace(values)); };
export default interpolate;
